const Grid = {
  init: () => {
    Grid.gridItems = document.querySelectorAll('.js-gridItem:not(.grid__item--hidden)');
    Grid.gridItems.forEach((item, i) => {
      var h = 200 + i * 100;
      setTimeout(function() {
        item.classList.remove('grid__item--opacity')
      }, h);
    });
  }
};

export default Grid;
